module.exports = __webpack_public_path__ + "static/media/190-Mobile-Banner@1x.0cec8cf6.jpg";